import { Checkbox, CircularProgress, Popper } from "@mui/material";
import PagePagination from "../../common/particles.jsx/PagePagination";
import { useMutation } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { getApprovalPbfList } from "../../../services/approvalApi";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import toIDR from "../../hooks/toIDR";
import { MdCheckCircleOutline, MdOutlineCancel } from "react-icons/md";
import ModalApprovalPbf from "./ModalApprovalPbf";
import { getSpPrintPbf } from "../../../services/purchaseApi";
import { LuDownload } from "react-icons/lu";
import ErrorPopup from "../../common/particles.jsx/ErrorPopup";

const ApprovalPbfList = () => {
  const navigate = useNavigate();

  const [reqBody, setReqBody] = useState({
    search: "",
    status: "",
    approval_status: "",
    start_date: "",
    end_date: "",
    sort: "desc",
    sort_order: "desc",
    offset: 1,
    limit: 10,
  });
  const [moreProductArr, setMoreProductArr] = useState([]);
  const [anchorElMoreProduct, setAnchorElMoreProduct] = useState(null);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [openActionModal, setOpenActionModal] = useState(false);
  const [printInv, setPrintInv] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [orderArr, setOrderArr] = useState([]);

  const handleChangeStatus = (item, isAccept) => {
    setSelectedRequest({
      uid: item.map((ord) => ord.invoice_uid),
      invNum: item.map((ord) => ord.invoice_no),
      action: isAccept,
    });
    setOpenActionModal(true);
  };

  const handleSelectAll = (checked) => {
    if (!dataList && isLoadingList) return;

    if (dataList) {
      var tempArr = [...orderArr];
      dataList.approvals.map((item) => {
        var foundIndex = tempArr.findIndex(
          (ord) => ord.invoice_uid === item.invoice_uid,
        );

        // if checked append items not found
        if (foundIndex < 0 && checked && item.approval_status === "pending")
          tempArr.push(item);
        // if not checked remove all datalist found
        if (foundIndex >= 0 && !checked && item.approval_status === "pending")
          tempArr = [
            ...tempArr.slice(0, foundIndex),
            ...tempArr.slice(foundIndex + 1),
          ];
      });

      setOrderArr(tempArr);
    }
  };

  const isAllChecked = () => {
    var isAll = true;

    if (!dataList) return;
    if (dataList.approvals.every((item) => item.approval_status !== "pending"))
      return false;
    else {
      dataList.approvals
        .filter((item) => item.approval_status === "pending")
        .map((item) => {
          var foundItem = orderArr.find(
            (ord) => ord.invoice_uid === item.invoice_uid,
          );

          if (!foundItem) isAll = false;
          return isAll;
        });
      return isAll;
    }
  };

  const {
    mutate: mutateList,
    data: dataList,
    isLoading: isLoadingList,
  } = useMutation({ mutationFn: getApprovalPbfList });

  const { mutate: mutateSP, isLoading: isLoadingSP } = useMutation({
    mutationFn: getSpPrintPbf,
    onSuccess: (data) => {
      if (!data) return;

      const url = window.URL.createObjectURL(data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `SP OLIN ${printInv}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      setPrintInv(null);
    },
    onError: (err) =>
      setErrorMessage(err.message?.id ? err.message.id : err.message),
  });

  useEffect(() => {
    mutateList(reqBody);
  }, [reqBody]);

  return (
    <div className="text-[12px] mb-[60px]">
      {orderArr.length > 0 ? (
        <div className=" fixed bottom-4 left-0 lg:left-[260px] min-h-[60px] px-[20px] py-[10px] w-full lg:w-[calc(100%-260px)] p-4 z-50">
          <div
            className={`rounded-md p-2 bg-[#121a2b] text-white shadow-lg shadow-slate-900/20 shadow-b-2 shadow-r-[3px] -shadow-spread-2 text-[12px] flex items-center justify-between gap-4`}
          >
            <div>
              <p className="text-[14px] font-bold">
                {orderArr.length} Transaksi Dipilih
              </p>
            </div>
            <div className="flex gap-2 items-center">
              <button
                type="button"
                className="bg-white text-[#121a2b] hover:bg-gray-100 py-2 px-4 rounded-md font-bold"
                onClick={() => setOrderArr([])}
              >
                Batal
              </button>

              <div className="flex gap-2">
                <button
                  className="w-full rounded-md py-2 px-4 bg-blue-600 text-white hover:bg-blue-700 disabled:bg-gray-300 disabled:text-white"
                  onClick={() => {
                    handleChangeStatus(orderArr, 1);
                  }}
                  disabled={orderArr.every(
                    (item) => item.approval_status !== "pending",
                  )}
                >
                  Terima
                </button>
                <button
                  className="w-full rounded-md py-2 px-4 bg-red-500 text-white hover:bg-red-700 disabled:bg-gray-300 disabled:text-white"
                  onClick={() => {
                    handleChangeStatus(orderArr, 2);
                  }}
                  disabled={orderArr.every(
                    (item) => item.approval_status !== "pending",
                  )}
                >
                  Tolak
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      <div className="flex w-full mb-4">
        <div className="w-full">
          <div className="block overflow-x-auto w-full rounded-md">
            <table className="w-full overflow-x-auto rounded-md border-collapse">
              <thead className="bg-blue-500 text-white">
                <tr>
                  <th className="p-2 text-center">
                    <Checkbox
                      checked={
                        dataList && dataList.approvals ? isAllChecked() : false
                      }
                      onChange={(_, checked) => handleSelectAll(checked)}
                      disabled={
                        !dataList ||
                        isLoadingList ||
                        dataList.approvals.every(
                          (item) => item.approval_status !== "pending",
                        )
                      }
                    />
                  </th>
                  <th className="p-2 text-center">No</th>
                  <th className="p-2 text-left whitespace-nowrap">
                    Tanggal Order
                  </th>
                  <th className="p-2 text-left whitespace-nowrap">Jam Order</th>
                  <th className="p-2 text-left whitespace-nowrap">No SP</th>
                  <th className="p-2 text-left whitespace-nowrap min-w-[250px]">
                    Produk
                  </th>
                  <th className="p-2 text-left whitespace-nowrap">
                    Total Harga
                  </th>
                  <th className="p-2 text-left whitespace-nowrap">Print SP</th>
                  <th className="p-2 text-center whitespace-nowrap">Action</th>
                </tr>
              </thead>
              <tbody>
                {dataList && !isLoadingList && dataList.total_data > 0 ? (
                  dataList.approvals.map((item, i) => (
                    <tr className="border" key={i}>
                      <td className="p-2 text-center">
                        <Checkbox
                          disabled={item.approval_status !== "pending"}
                          checked={Boolean(
                            orderArr.find(
                              (ord) => ord.invoice_uid === item.invoice_uid,
                            ),
                          )}
                          onChange={() => {
                            const foundIndex = orderArr.findIndex(
                              (ord) => ord.invoice_uid === item.invoice_uid,
                            );

                            setOrderArr(
                              foundIndex < 0
                                ? [...orderArr, item]
                                : [
                                    ...orderArr.slice(0, foundIndex),
                                    ...orderArr.slice(foundIndex + 1),
                                  ],
                            );
                          }}
                        />
                      </td>
                      <td className="p-2 text-center">
                        {(reqBody.offset - 1) * reqBody.limit + (i + 1)}
                      </td>
                      <td className="p-2 text-left">
                        {moment(item.order_date).format("DD/MM/YYYY")}
                      </td>
                      <td className="p-2 text-left">
                        {moment(item.order_date).format("HH:mm")}
                      </td>
                      <td
                        className="p-2 text-left text-blue-500 hover:text-gray-300 cursor-pointer text-nowrap"
                        onClick={() =>
                          navigate(`/approval-pbf/detail/${item.invoice_uid}`)
                        }
                      >
                        {item.po_number.split(":")[1]}
                      </td>
                      <td className="p-2 text-left">
                        <div className="w-full flex justify-between gap-4 items-center">
                          <p>
                            {item.product_names ? item.product_names[0] : "-"}
                          </p>
                          {item.product_names &&
                          item.product_names.length > 1 ? (
                            <p
                              className="text-blue-500 cursor-pointer text-nowrap whitespace-nowrap"
                              onMouseEnter={(e) => {
                                setMoreProductArr(item.product_names.slice(1));
                                setAnchorElMoreProduct(e.currentTarget);
                              }}
                              onMouseLeave={() => setAnchorElMoreProduct(null)}
                            >
                              +{item.product_names.length - 1} Lainnya
                            </p>
                          ) : null}
                        </div>
                      </td>
                      <td className="p-2 text-left">
                        {toIDR(item.grand_total)}
                      </td>
                      <td className="p-2">
                        <button
                          onClick={() => {
                            setPrintInv(item.invoice_no.split(": ")[1]);
                            setTimeout(() => {
                              mutateSP({
                                invNum: item.invoice_uid,
                              });
                            }, 500);
                          }}
                          className="border-2 border-blue-500 text-blue-500 hover:bg-gray-100 rounded-md w-full p-2 disabled:bg-gray-300 disabled:text-white"
                          disabled={
                            isLoadingSP &&
                            printInv === item.invoice_no.split(": ")[1]
                          }
                        >
                          {isLoadingSP &&
                          printInv === item.invoice_no.split(": ")[1] ? (
                            <CircularProgress size={10} />
                          ) : (
                            <div className="flex items-center justify-center gap-2">
                              <LuDownload />
                            </div>
                          )}
                        </button>
                      </td>
                      <td className="p-2 text-left">
                        {item.approval_status === "pending" ? (
                          <div className="flex gap-2 items-center justify-center">
                            <MdOutlineCancel
                              className="text-[18px] text-red-500 cursor-pointer hover:text-gray-300"
                              onClick={() => {
                                handleChangeStatus([item], 2);
                              }}
                            />
                            <MdCheckCircleOutline
                              className="text-[18px] text-blue-500 cursor-pointer hover:text-gray-300"
                              onClick={() => {
                                handleChangeStatus([item], 1);
                              }}
                            />
                          </div>
                        ) : item.approval_status === "approved" ? (
                          <p className="text-green-500 text-center">Diterima</p>
                        ) : item.approval_status === "rejected" ? (
                          <p className="text-red-500 text-center">Ditolak</p>
                        ) : null}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr className="border">
                    <td className="p-2 text-center" colSpan={10}>
                      {isLoadingList ? (
                        <CircularProgress size={20} />
                      ) : (
                        "Tidak ada data approval"
                      )}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {dataList && dataList.total_data > 0 && dataList.approvals !== null ? (
        <>
          <div className="mb-4">
            <PagePagination
              offset={reqBody.offset}
              limit={reqBody.limit}
              setOffset={(e) =>
                setReqBody((prevVal) => ({ ...prevVal, offset: e }))
              }
              setLimit={(e) => {
                setReqBody({ offset: 1, limit: e });
              }}
              total={dataList.total_data}
            />
          </div>
        </>
      ) : null}

      {selectedRequest ? (
        <ModalApprovalPbf
          open={openActionModal && selectedRequest}
          setOpen={setOpenActionModal}
          selectedRequest={selectedRequest}
          onSuccessFunc={() => {
            setSelectedRequest(null);
            setOrderArr([]);
            setReqBody((prevVal) => ({ ...prevVal, offset: 1 }));
            mutateList({ offset: 1, limit: reqBody.limit });
          }}
        />
      ) : null}

      <Popper
        placement="bottom"
        open={Boolean(anchorElMoreProduct)}
        anchorEl={anchorElMoreProduct}
        sx={{ maxWidth: "200px" }}
        modifiers={[
          {
            name: "arrow",
            enabled: true,
          },
        ]}
      >
        <div className="bg-white text-[10px] p-2 rounded-md border text-wrap whitespace-wrap overflow-hidden break-words">
          {moreProductArr.map((item, i) => `${i + 1}. ${item}`).join(", ")}
        </div>
      </Popper>

      <ErrorPopup
        errorMessage={errorMessage}
        setErrorMessage={setErrorMessage}
      />
    </div>
  );
};

export default ApprovalPbfList;
